export default "__VITE_ASSET__BsrlFbMZ__"